import { render, staticRenderFns } from "./ShareStorageNFC.vue?vue&type=template&id=39d1e190"
import script from "./ShareStorageNFC.vue?vue&type=script&lang=js"
export * from "./ShareStorageNFC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports